module.exports = __webpack_public_path__ + "img/13.93fc91d5.jpg";